import { useContext, useEffect, useState } from 'react';
import { toast, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';
import TopLoadingBar from '../topLoadingBar/topLoadingBar';
import OrganizationContext from '../../context/OrganizationContext/OrganizationContext';
import { ERROR_CODE } from '../../constant';
import LogOut from '../../utils/logout';
import { useNavigate } from 'react-router';
import BillManagementItem from './BillManagementItem';
import BillManagementContext from '../../context/BillManagementContext/BillManagementContext';
import {
  Add_Bill_Management,
  Bill_Management_Detail,
  Bill_Management_List,
  Edit_Bill_Management
} from '../../api/BillManagementApi/BillManagementApi';
import BillManagementAddModel from './BillManagementAddModel';
import BillAddModel from './BillAddModel';

const BillManagement = () => {
  const {
    setformvalue,
    setModal,
    sortOrder,
    setSortOrder,
    sortBy,
    setSortBy,
    filter,
    modal,
    progress,
    setProgress,
    setToggle,
    formData,
    setFormData,
    filterOrderId,
    editIndex,
    seteditIndex,
    togglesubmit,
    vendorId,
    setVendorId,
    setBillModal,
    billForm,
    setBillForm
  } = useContext(BillManagementContext);
  const { loaderShow, setLoaderShow, responseLoader, setResponseLoader } = useContext(OrganizationContext);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const history = useNavigate();
  const [error, setError] = useState(false);
  const [reportData, setReportData] = useState({ totalBillAmount: 0, totalDueAmount: 0, totalPaidAmount: 0 });

  /**
   * Accommodation_List List api call function and useEffect use to call function
   */

  const getData = async () => {
    setResponseLoader(!responseLoader);
    try {
      let paramsObj = {
        pageNumber: page,
        recordsPerPage: pageSize,
        sortOrder,
        sortBy
      };
      const activeFilters = Object.fromEntries(Object.entries(filter).filter(([_, v]) => v));
      paramsObj['search'] = activeFilters;
      if (filter.name) {
        paramsObj['search'] = { ...filter };
      }

      const { data } = await Bill_Management_List(paramsObj);
      if (data.status === 200) {
        setformvalue(data.payload.data);
        setReportData(data.payload.reportData || { totalBillAmount: 0, totalDueAmount: 0, totalPaidAmount: 0 });
        setRecord(data.pager.totalRecords);
        setResponseLoader(false);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      setResponseLoader(false);
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  useEffect(() => {
    getData();
    setProgress(100);
  }, [page, pageSize, sortOrder, sortBy, filter, filterOrderId]);

  /**
   * Add donation master model open function call
   */

  const AddModel = () => {
    EmptyFeild();
    setModal(true);
    setToggle(true);
  };
  const AddBillModel = (vendorId) => {
    console.log('vendorId >> ', vendorId);
    setBillForm((prev) => {
      return {
        ...prev,
        vendorId: vendorId
      };
    });
    EmptyBillFeild();
    setBillModal(true);
  };

  /**
   * sorting funcion call
   */

  const sorting = (col) => {
    if (sortOrder === '') {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder('ASC');
    }
    if (sortOrder === 'ASC') {
      let found = col.find((obj) => {
        return obj.field;
      });
      setSortBy(found.field);
      setSortOrder('DSC');
    }
    if (sortOrder === 'DSC') {
      setSortBy();
      setSortOrder('');
    }
  };

  const editHandle = async (vendorId) => {
    setVendorId(vendorId);
    setLoaderShow(!loaderShow);
    try {
      const { data } = await Bill_Management_Detail(vendorId);
      if (data.status === 200) {
        setToggle(false);
        seteditIndex(vendorId);
        //ORG EDIT
        console.log('data >> ', data);

        let payload = data.payload.data;
        setFormData({
          name: payload?.name,
          phone: payload?.phone,
          address: payload?.address
        });
        // setTrustId(payload.trustId ? payload.trustId : null);
        setLoaderShow(false);
        setModal(true);
      } else {
        setformvalue([]);
      }
    } catch (error) {
      if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
        LogOut(history);
      }
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
      setLoaderShow(false);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (formData?.name.length === 0 || formData?.phone.length === 0 || formData?.address.length === 0) {
      setError(true);
    } else {
      if (editIndex !== -1 && !togglesubmit) {
        try {
          const { data } = await Edit_Bill_Management(formData, vendorId);
          if (data.status === 200) {
            toast.success(data.message, {
              autoClose: 1000
            });
            setModal(false);
            getData();
            EmptyFeild();
          }
        } catch (error) {
          if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
            LogOut(history);
          }
          toast.error(error?.response?.data?.message, {
            autoClose: 1000,
            transition: Zoom
          });
          setLoaderShow(false);
        }
      } else {
        try {
          setLoaderShow(!loaderShow);
          const { data } = await Add_Bill_Management(formData);
          if (data.status === 200) {
            toast.success(data.message, {
              autoClose: 1000,
              transition: Zoom
            });
            setModal(false);
            getData();
            EmptyFeild();
          }
        } catch (error) {
          if (error?.response?.data?.status === ERROR_CODE.UNAUTHORIZED) {
            LogOut(history);
          }
          toast.error(error?.response?.data?.message, {
            autoClose: 1000,
            transition: Zoom
          });
          setLoaderShow(false);
        }
      }
    }
  };

  const EmptyFeild = () => {
    setFormData({ name: '', phone: '', address: '' });
    setLoaderShow(false);
    setVendorId('');
    seteditIndex('');
  };
  const EmptyBillFeild = () => {
    setBillForm({
      vendorId: '',
      billNo: '',
      billDate: '',
      totalAmount: '',
      paidAmount: '',
      paymentMode: '',
      billImage: '',
      notes: '',
      referenceNo: ''
    });
    setLoaderShow(false);
  };

  const onBillSubmit = (e) => {
    e.preventDefault();
    if (billForm?.vendorId.length === 0 || billForm?.billDate.length === 0 || billForm?.totalAmount.length === 0) {
      setError(true);
    } else if (
      billForm?.vendorId.length &&
      (billForm?.paymentMode.length === 0 || billForm?.referenceNo.length === 0)
    ) {
      setError(true);
    }
  };

  const close = () => {
    setModal(!modal);
    EmptyFeild();
  };
  const billClose = () => {
    setBillModal(false);
    EmptyBillFeild();
  };

  return (
    <>
      <div>
        <TopLoadingBar progress={progress} setProgress={setProgress} />
        <BillManagementAddModel onSubmit={onSubmit} close={close} error={error} />
        <BillAddModel onSubmit={onBillSubmit} close={billClose} error={error} />
        <BillManagementItem
          sorting={sorting}
          AddModel={AddModel}
          AddBillModel={AddBillModel}
          editHandle={editHandle}
          setPage={setPage}
          setPageSize={setPageSize}
          pageSize={pageSize}
          page={page}
          record={record}
          getData={getData}
          reportData={reportData}
        />
      </div>
    </>
  );
};
export default BillManagement;
